export default __webpack_public_path__ + "817e4500f031950331db156fe7cb5f23.svg";